import Listing from './listing';

export default Listing;
